module.exports = __webpack_public_path__ + "img/feature-truck-energy.5bd00792.jpg";